module.exports = __webpack_public_path__ + "static/media/login-background.5a3500fa.jpg";